module.exports = __webpack_public_path__ + "static/media/sad-smile.5539859a.svg";